import React from "react";
import Osm from "./osm";
import Google from "./google";
import { useSelector } from "react-redux";


export const MapTrackDriver_Route_PinOnMap = (props) => {

         if (props.mapType == "google") {
            return <Google routeDetails={props.routeDetails} />
        } else {
            return <Osm routeDetails={props.routeDetails} />
        }
 


};




